"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTagsForApiEndpointVisibilityInfo = void 0;
const tagKeys_1 = require("../tagKeys");
const getApiEndpointStatusClass_1 = require("./getApiEndpointStatusClass");
const buildTagsForApiEndpointVisibilityInfo = (endpointInfo, tags) => {
    const tagsToSend = {
        ...tags,
        [tagKeys_1.TagKey.API_ENDPOINT_METHOD]: endpointInfo.method,
        [tagKeys_1.TagKey.API_ENDPOINT_ROUTE]: endpointInfo.route,
        [tagKeys_1.TagKey.API_ENDPOINT_STATUS]: String(endpointInfo.httpStatus),
        [tagKeys_1.TagKey.CALLER]: endpointInfo.caller,
    };
    if (typeof endpointInfo.directCaller !== "undefined") {
        tagsToSend[tagKeys_1.TagKey.DIRECT_CALLER] = endpointInfo.directCaller;
    }
    if (typeof endpointInfo.directCallerVersion !== "undefined") {
        tagsToSend[tagKeys_1.TagKey.DIRECT_CALLER_VERSION] = endpointInfo.directCallerVersion;
    }
    const httpStatusClassValue = (0, getApiEndpointStatusClass_1.getApiEndpointStatusClass)(endpointInfo.httpStatus);
    if (httpStatusClassValue) {
        tagsToSend[tagKeys_1.TagKey.API_ENDPOINT_STATUS_CLASS] = httpStatusClassValue;
    }
    return tagsToSend;
};
exports.buildTagsForApiEndpointVisibilityInfo = buildTagsForApiEndpointVisibilityInfo;
//# sourceMappingURL=buildTagsForApiEndpointVisibilityInfo.js.map